'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTabName = function getTabName(_ref) {
  var tab = _ref.tab,
      type = _ref.type;

  if (tab) {
    return tab;
  }

  return type.split('_').join(' ').toUpperCase();
};

exports.default = getTabName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/PageFooter/getTabName.js
// module id = 1110
// module chunks = 0